import { render } from "./ServiceInfo_04.vue?vue&type=template&id=478316fe"
import script from "./ServiceInfo_04.vue?vue&type=script&lang=js"
export * from "./ServiceInfo_04.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__